import { render } from "./PPTImage.vue?vue&type=template&id=197f4fec"
import script from "./PPTImage.vue?vue&type=script&lang=js"
export * from "./PPTImage.vue?vue&type=script&lang=js"

import "./PPTImage.vue?vue&type=style&index=0&id=197f4fec&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__